import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { RebuildLogo } from './RebuildLogo';

/** Logo brick layout is ~410px wide at scale 1.02; scale down on narrow viewports to avoid horizontal overflow. */
function computeLogoScale(innerWidth) {
  const padded = Math.max(0, innerWidth - 48);
  return Math.min(1.02, Math.max(0.62, padded / 410));
}

function useHeaderLogoScale() {
  const [scale, setScale] = useState(() =>
    typeof window === 'undefined' ? 1.02 : computeLogoScale(window.innerWidth)
  );
  useEffect(() => {
    const update = () => setScale(computeLogoScale(window.innerWidth));
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return scale;
}

const pageVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 }
};

export const PageWrapper = ({
  children,
  className = '',
  hideTitle = false,
  contentClassName = '',
  omitBottomNavPadding = false,
}) => {
  const headerLogoScale = useHeaderLogoScale();

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className={`h-dvh max-h-dvh min-h-0 w-full max-w-full min-w-0 flex flex-col overflow-hidden overflow-x-hidden ${className}`}
    >
      {!hideTitle && (
        <div className="logo-area flex-shrink-0 w-full max-w-full overflow-x-hidden">
          <div className="max-w-md mx-auto w-full min-w-0 px-6 pt-4 pb-1 flex justify-center">
            <RebuildLogo scale={headerLogoScale} />
          </div>
        </div>
      )}
      <div
        className={`content-area flex-grow min-h-0 min-w-0 w-full overflow-x-hidden flex flex-col ${contentClassName}`}
        style={
          omitBottomNavPadding
            ? undefined
            : { paddingBottom: 'calc(5.5rem + env(safe-area-inset-bottom, 0px))' }
        }
      >
        {children}
      </div>
    </motion.div>
  );
};

export default PageWrapper;